import Request from './request'
import store from '@/store.js'
import i18n from '@/i18n'
import snackbar from '@/plugins/snackbar'

async function fetch(data) {
  return Request('get', "api/stock-takes/index", data);
}

async function fetchOne(id, data) {
  return Request('get', "api/stock-takes/view/" + id, data);
}

async function cancel(id) {
  return Request('delete', "api/stock-takes/cancel/" + id);
}

async function addStockTake(data) {
  return Request('post', "api/stock-takes/add" , data);
}

async function addStockTakeView(data) {
  return Request('post', "api/stock-takes/add-view" , data);
}

async function stockTake(data) {
  return Request('post', "api/stock-takes/stock-take" , data)
}

async function detailExport(id) {
  store.dispatch('fullscreenLoading')
  const response = await Request('get', 'api/stock-takes/detail-export/'+id)
  if (response.data && response.data.status.isOK()) {
    snackbar.info(i18n.t('Export.recordedHint'))
  }
  store.dispatch('fullscreenLoadingStop')
  return response
}

async function stockTakeCurrentHistoryExport(id) {
  store.dispatch('fullscreenLoading')
  const response = await Request('get', 'api/stock-takes/stock-take-current-history-export/'+id)
  if (response.data && response.data.status.isOK()) {
    snackbar.info(i18n.t('Export.recordedHint'))
  }
  store.dispatch('fullscreenLoadingStop')
  return response
}


async function commonTemplatexport(data){ //导出普通盘点下载
  store.dispatch("fullscreenLoading");
    const response = await Request('get',"api/stock-takes/common-template-export",data)
    if(response.data && response.data.status.isOK()){
        snackbar.info(i18n.t("Export.recordedHint"))
    }
    store.dispatch("fullscreenLoadingStop")
    return response
}

async function importCommonTemplate(file) {      //普通模板导入
  var data = new FormData()
  data.append('excel', file)
  return Request('post', "api/stock-takes/import-common-template-save", data)
}

async function editStockTake(data) {
  return Request('post', "api/stock-takes/edit",data)
}

async function stockTakeOrderPrint(id) {
  return Request('get', "api/stock-takes/stock-take-print/" + id)
}

async function stockTakeOrdersPrint(data) {
  return Request('get', "api/stock-takes/stock-takes-print/", data)
}

export default {
  fetch,
  fetchOne,
  cancel,
  addStockTake,
  stockTake,
  addStockTakeView,
  detailExport,
  stockTakeCurrentHistoryExport,
  commonTemplatexport,
  importCommonTemplate,
  editStockTake,
  stockTakeOrderPrint,
  stockTakeOrdersPrint,
};